/**
 * @generated SignedSource<<90ad5dd244bc7ff58799bef1ce84c8f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutFooter_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_buyer">;
  readonly " $fragmentType": "CheckoutFooter_buyer";
};
export type CheckoutFooter_buyer$key = {
  readonly " $data"?: CheckoutFooter_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFooter_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6f1231a44eb28b6fd28ae70efbc937e1";

export default node;
